module.exports = __webpack_public_path__ + "img/step7-b.9b006d72.png";